/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExpectedApprover } from './expected-approver';
import { EmployeesEmployeesEmployee } from './employees-employees-employee';

export interface PositionRequestApproval {
  /**
   * The unique id of the position request approval.
   */
  id: string;
  /**
   * The unique id of the employee that originally approved the position request approval.
   */
  originalApproverEmployeeId?: string | null;
  approverEmployee?: EmployeesEmployeesEmployee;
  expectedApprover?: ExpectedApprover;
  /**
   * The unique id of the employee that created the position request approval.
   */
  createdById: string;
  /**
   * The date the position request approval was created.
   */
  createdAt: string;
  /**
   * The unique id of the employee that last updated the position request approval.
   */
  updatedById: string;
  /**
   * The date the position request approval was last modified.
   */
  updatedAt: string;
  /**
   * The unique id of the employee that last updated the position request approval as emulation (or null if the last modification did not use emulation).
   */
  emulatedById?: string | null;
  /**
   * The unique name of the approval step this approval is linked to.
   */
  stepName: string | null;
  /**
   * The display name of the approval step, set for GID approver steps. End users see this name instead of the step name.
   */
  displayName?: string | null;
  /**
   * The current state of the position request approval.
   */
  state: PositionRequestApprovalStateEnum;
  /**
   * Whether the position request approval is required.
   */
  isRequired?: boolean;
  /**
   * The due date of the position request approval.
   */
  dueDate?: string | null;
  /**
   * Whether the position request approval was acknowledged by an admin.
   */
  acknowledgedByAdmin?: boolean;
  /**
   * Whether the position request approval was acknowledged as part of a veto.
   */
  acknowledgedAsVeto?: boolean;
}
export enum PositionRequestApprovalStateEnum {
  Open = 'Open',
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
